export const Permission = {
  data: () => ({}),
  methods: {
    ShowPermisos ({ permisos, tableMain }) {
      if (permisos.descripcion.special === 'all-access') {
        tableMain.header.options.map(action => {
          action.hidden = ''
        })
        tableMain.body.actions.map(action => {
          action.hidden = ''
        })
        return
      }
      tableMain.header.options.map(action => {
        permisos.permisos.map(item => {
          if (action.code !== 'libre') {
            if (action.code === item.slug) {
              action.hidden = ''
            }
          }
        })
      })
      tableMain.body.actions.map(action => {
        permisos.permisos.map(item => {
          if (action.code !== 'libre') {
            if (action.code === item.slug) {
              action.hidden = ''
            }
          }
        })
      })
    },

    PermisosMenu (permisos, menuGral) {
      if (permisos && permisos.descripcion.special === 'all-access') {
        menuGral.map(action => {
          if (action.group) {
            action.hidden = ''
            action.items.map(subItems => {
              if (subItems.group) {
                subItems.hidden = ''
                subItems.items.map(subsubItems => {
                  subsubItems.hidden = ''
                })
              } else {
                subItems.hidden = ''
              }
            })
          } else {
            action.hidden = ''
          }
        })
        return
      }
      menuGral.map(action => {
        permisos.permisos.map(item => {
          if (action.group) {
            if (item.slug === action.id) {
              action.hidden = ''
              action.items.map(subItems => {
                permisos.permisos.map(per => {
                  if (subItems.group) {
                    if (per.slug === subItems.id) {
                      subItems.hidden = ''
                      subItems.items.map(subsubItems => {
                        permisos.permisos.map(persub => {
                          if (persub.slug === subsubItems.id) {
                            subsubItems.hidden = ''
                          }
                        })
                      })
                    }
                  } else {
                    if (per.slug === subItems.id) {
                      subItems.hidden = ''
                    }
                  }
                })
              })
            }
          } else {
            if (item.slug === action.id) action.hidden = ''
          }
        })
      })
    }
  }
}
